/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, Box, Text } from 'theme-ui'

import Button from './../../atoms/Button'
import NumbersList from './../../molecules/NumbersList'

import { TextWithListProps } from './types'
import {
  TextWithListStyled,
  TextWithListTitleStyled,
  TextWithListSubtitleStyled,
  TextWithListContentStyled,
  TextWithListNumbersStyled,
  TextWithListActionStyled,
  TextWithListInnerStyled
} from './styles'

const TextWithList: React.FC<TextWithListProps> = ({ data: { cta, title, subtitle, content, isAlignLeft, listData, description } }) => (
  <TextWithListStyled>
    <TextWithListInnerStyled {...{ isAlignLeft }}>
      {title && (
        <TextWithListTitleStyled>
          <Text
            as="h2"
            sx={{
              variant: 'headingRaleway6',
              fontWeight: 'bold',
              color: 'green'
            }}
          >
            {title}
          </Text>
        </TextWithListTitleStyled>
      )}
      {subtitle && (
        <TextWithListSubtitleStyled>
          <Text
            as="p"
            sx={{
              variant: 'bodyMontserrat9',
              fontWeight: 'medium'
            }}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        </TextWithListSubtitleStyled>
      )}
      {content && (
        <TextWithListContentStyled>
          <Text
            as="p"
            sx={{
              variant: 'bodyMontserrat5',
              fontFamily: 'primary'
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </TextWithListContentStyled>
      )}
      {listData && (
        <TextWithListNumbersStyled>
          <NumbersList data={listData} />
        </TextWithListNumbersStyled>
      )}
      {description && (
        <Box
          sx={{
            marginBottom: ['28px', '20px']
          }}
        >
          <Text
            sx={{
              variant: 'bodyMontserrat22',
              textAlign: 'center'
            }}
          >
            {description}
          </Text>
        </Box>
      )}
      {cta && cta.urlText && (
        <TextWithListActionStyled>
          <Button variant="withArrow" {...cta} />
          {/* {cta.caption && (
            <Text
              sx={{
                variant: 'bodyMontserrat7',
                fontFamily: 'primary',
                marginTop: '5px'
              }}
            >
              {cta.caption}
            </Text>
          )} */}
        </TextWithListActionStyled>
      )}
    </TextWithListInnerStyled>
  </TextWithListStyled>
)

export default TextWithList
